module.exports = __webpack_public_path__ + "img/red_054.d3a47e58.png";